import React, { useEffect, useState } from 'react';

function Index({ links }) {
  return <section></section>;
}

export default Index;
